import axios from 'axios';

const add = (customPath, id, idUser) => axios.put(`/fornecedor/${customPath}/${id}/responsaveis/${idUser}`, {});
const remove = (customPath, id, idUser) => axios.delete(`/fornecedor/${customPath}/${id}/responsaveis/${idUser}`);

/*
* Adicionar responsáveis (PUT/DELETE)
/api/fornecedor/solicitacoes-respostas/{idSolicitacao}/responsaveis/{idUser}
/api/fornecedor/compras/{idCompra}/responsaveis/{idUser}
/api/fornecedor/compras-conjuntas/{idCompra}/responsaveis/{idUser}
* */

export default {
  add,
  remove,
};
